'use client';

import dynamic from 'next/dynamic';
import { Skeleton } from '@/components/ui/skeleton';

const IotDashboard = dynamic(() => import('@/components/sections/iot-dashboard').then(mod => mod.IotDashboard), {
  ssr: false,
  loading: () => <Skeleton className="h-[400px] w-full" />,
});

const SmartRetailDashboard = dynamic(() => import('@/components/sections/smart-retail-dashboard').then(mod => mod.SmartRetailDashboard), {
  ssr: false,
  loading: () => <Skeleton className="h-[400px] w-full" />,
});

const Services = dynamic(() => import('@/components/sections/services').then(mod => mod.Services), {
  ssr: false,
  loading: () => <Skeleton className="h-[500px] w-full" />,
});

const Contact = dynamic(() => import('@/components/sections/contact').then(mod => mod.Contact), {
    ssr: false,
    loading: () => <Skeleton className="h-[500px] w-full" />,
});


export function HomeClient() {
    return (
        <>
            <Services />
            <IotDashboard />
            <SmartRetailDashboard />
            <Contact />
        </>
    )
}
